export const getDaysToDeadline = (deadLine) => {
  const now = new Date();
  const deadlineDate = new Date(deadLine);
  
  const diffTime = deadlineDate.getTime() - now.getTime();
  
  if (diffTime <= 0) return 0;
  
  const diffDays = Math.trunc(diffTime / (1000 * 60 * 60 * 24));
  
  return diffDays <= 3 ? diffDays : null;
};
